export default __webpack_public_path__ + "static/media/floor-7.5d4c1818.jpg";